/* eslint-disable arrow-body-style */
import { Button, ModalFooter } from 'reactstrap'
import Loading from 'Shared/Loading'

const ForgotMembershipModalFooter = ({ loading, toggle, sendEmail }) => {
  return (
    <ModalFooter className="pt-3">
      <Button color="outline-salmon" onClick={toggle}>Cancel</Button>

      <Button className="d-flex" color="salmon" onClick={sendEmail}>
        Send Email

        {loading && <Loading className="ms-2" size="1x" />}
      </Button>
    </ModalFooter>
  )
}

export default ForgotMembershipModalFooter
